<template>
  <section class="login" :style="bg_style">
    <!--<img src="../../assets/images/logo.png" alt="">-->
    <div class="loform">
      <header>亿用ERP管理系统</header>
      <el-form :model="formData" :rules="rules" ref="formData" v-if="!showQrcode">
        <el-form-item prop="username">
          <el-input v-model="formData.username" size="medium" placeholder="登录账号" class="change-opacity"></el-input>
        </el-form-item>
        <el-form-item prop="password_hash">
          <el-input type="password" size="medium" v-model="formData.password_hash" placeholder="登录密码" class="change-opacity"></el-input>
        </el-form-item>
        <el-form-item class="verification-code" prop="ding_verification_code">
          <el-input v-model.trim="formData.ding_verification_code" size="medium" placeholder="验证码" @keyup.enter.native="loginBtn" class="change-opacity"></el-input>
          <el-button size="medium" @click="getCode(formData)" :disabled="!show" class="change-opacity2">
            <span v-show="show">获取验证码</span>
            <span v-show="!show" class="count">{{count}} s</span>
          </el-button>
        </el-form-item>

        <el-button class="login-btn" size="medium" type="primary" @click="loginBtn">登录</el-button>
      </el-form>
      <div id="qrCodeContainer" v-show="showQrcode"></div>
      <div class="qr_code" @click="changeForm">
        <i class="iconfont" v-show="showQrcode">&#xe605;</i>
        <i class="iconfont" v-show="!showQrcode">&#xe642;</i>
      </div>
    </div>
    <p class="record">
      <a href="http://www.beian.miit.gov.cn" style="text-decoration: underline">{{recordNumber}}</a>
    </p>

  </section>
</template>
<script>
export default {
  data() {
    return {
      recordNumber:'',
      get_disable: false,
      set_disable: false,
      // 再次发送短信剩余时间
      time: 60,
      prompt_info: "获取验证码",
      formData: {
        username: "",
        password_hash: "",
        ding_verification_code: ""
      },
      show: true,
      count: "",
      timer: null,
      rules: {
          username:[{ required: true, message: '用户名不能为空', trigger: 'blur' }],
          password_hash:[{ required: true, message: '密码不能为空', trigger: 'blur' }],
          ding_verification_code:[{ required: true, message: '验证码不能为空', trigger: 'blur' }],
      },
      user_info: {},
      showQrcode: false,
      redirectUrl: "",
      bg_style: {},
    };
  },
  created() {
    this.getActiveTheme();
    this.getRecordNumber();
    this.getLogin().catch(res => {
      this.renderDing();
    });
    //调用hanndleMessage
    if (typeof window.addEventListener != "undefined") {
      window.addEventListener("message", this.handleDingScan, false);
    } else if (typeof window.attachEvent != "undefined") {
      window.attachEvent("onmessage", this.handleDingScan);
    }
  },
  methods: {
    // 请求背景图
    getActiveTheme() {
      _api.get("/auth/default-theme/active-theme").then(res => {
        if(res.code == 0) {
          if(res.data.login_bg.length) {
            this.bg_style = {backgroundImage: `url(${res.data.login_bg[0].url})`};
          }
        }
      })
    },
    handleDingScan() {
      var origin = event.origin;
      if (origin == "https://login.dingtalk.com") {
        //判断是否来自ddLogin扫码事件。
        var loginTmpCode = event.data; //拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了
        this.scanQrCodeSuccess(loginTmpCode);
      }
    },
    scanQrCodeSuccess(loginTmpCode) {
      _g.toast("扫描成功", "success", 1000, () => {
        window.location.href =
          this.redirectUrl + "&loginTmpCode=" + loginTmpCode;
      });
    },
    renderDing() {
      _api.get("/index/site/get-ding-goto").then(res => {
        if (res.code === 0) {
          this.redirectUrl = res.data.redirectUrl;
          this.renderQrCode({
            id: "qrCodeContainer",
            goto: res.data.dingGoto,
            width: "100%",
            height: "300"
          });
        }
      });
    },
    getRecordNumber() {
      _api.get("/index/site/get-domain-name-record-number").then(res => {
        if (res.code === 0) {
          this.recordNumber = res.data;
        }else{
          this.recordNumber = '粤ICP备18026970号-2';
        }
      });
    },
    changeForm() {
      this.showQrcode = !this.showQrcode;
    },
    getLogin() {
      return new Promise((res, rej) => {
        _api.get("/index/site/get-login").then(res => {
          if (res.code === 0) {
            return this.gotoHome();
          }
          rej();
        });
      });
    },
    gotoHome() {
      return this.$router.push({ name: "index" });
    },
    getCode(formData) {
      const TIME_COUNT = 60;
      _api
        .post("/index/site/get-ding-code", { username: this.formData.username })
        .then(res => {
          _g.toast(res.message,res.code ===0?'success':'error');
        });
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;

        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    renderQrCode(a) {
      var e,
        c = document.createElement("iframe"),
        d = "https://login.dingtalk.com/login/qrcode.htm?goto=" + a.goto;
      (d += a.style ? "&style=" + encodeURIComponent(a.style) : ""),
        (d += a.href ? "&href=" + a.href : ""),
        (c.src = d),
        (c.frameBorder = "0"),
        (c.allowTransparency = "true"),
        (c.scrolling = "no"),
        (c.width = a.width ? a.width + "px" : "365px"),
        (c.height = a.height ? a.height + "px" : "400px"),
        (e = document.getElementById(a.id)),
        (e.innerHTML = ""),
        e.appendChild(c);
    },
    loginBtn() {
        this.$refs['formData'].validate(valid =>{
            if(!valid){
                return ;
            }
            _api.post("/index/site/login", this.formData).then(res => {
                if (res.code == 0) {
                    this.$message.success("登录成功！");
                    this.user_info = res.data;
                    lockr.set("userInfo", this.user_info);
                    this.gotoHome();
                }
                if (res.code == 2) {
                    this.gotoHome();
                }
                if ([3, 4, 5, 6].indexOf(res.code) > -1) {
                  this.$message.error(res.message);
                }
            });
        })
    }
  }
};
</script>


<style lang="scss" scoped>
.login {
  position: absolute;
  width: 100%;
  min-width: 1000px;
  height: 100%;
  padding: 15px;
  background-image: url("../../assets/images/login-bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;

  // background: rgba(500, 500,500, .2);
  // padding: 10px 15px;
  // border-radius: 4px;
  // box-shadow: 60px 10px 10px rgba(0, 0, 0, 0.2);
  header {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-style: normal;
    font-size: 16px;
    font-weight: 800;
    color: #6e6e6e;
    // color: #fff;
    border-bottom: 1px solid #ddd;
  }
  .el-button--medium {
    padding: 10px;
  }
  .el-form {
    padding-top: 22px;
    .verification-code {
      .el-input {
        width: 170px;
      }
      .el-button {
        width: 87px;
        margin-left: 10px;
      }
    }
  }
  .loform {
    width: 302px;
    height: 374px;
    box-sizing: border-box;
    position: absolute;
    right: 200px;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.8);
    padding: 10px 15px;
    border-radius: 4px;
    box-shadow: 60px 10px 10px rgba(0, 0, 0, 0.2);
    header {
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-style: normal;
      font-size: 16px;
      font-weight: 800;
      color: #6e6e6e;
      border-bottom: 1px solid #ddd;
      margin-bottom: 10px;
    }
    .el-form {
      padding-top: 22px;
      height: 304px;
      .verification-code {
        .el-input {
          width: 170px;
        }
        .el-button {
          width: 87px;
          margin-left: 10px;
        }
      }
    }
    .login-btn {
      display: block;
      width: 100%;
      letter-spacing: 15px;
      margin-bottom: 20px;
    }
    .qr_code {
      position: absolute;
      top: 10px;
      right: 0px;
      width: 50px;
      height: 50px;
      z-index: 99;
    }

    .qr_code:before {
      position: absolute;
      display: block;
      content: "";
      width: 0px;
      height: 0px;
      border-left: 0px solid transparent;
      border-right: 50px solid transparent;
      border-bottom: 50px solid rgba(255, 255, 255, 0.8);;
    }

    .qr_code i {
      font-size: 40px;
    }
  }
  .remark{
    position: fixed;
    bottom: 60px;
    right: 50px;
    color: #73f7f7;
    width: 50%;
    opacity: 0.8;
    span{
      display: block;
      font-weight: bold;
    }
  }
  .record{
    position: fixed;
    bottom: 10px;
    width: 100%;
    text-align: center;
    color: #ccc;
    font-size: 12px;
  }
  .change-opacity /deep/ input {
    background: rgba(255, 255, 255, 0.8);
  }
  .change-opacity2 {
    background: rgba(255, 255, 255, 0.8);
  }
}
</style>





// WEBPACK FOOTER //
// login.vue?b208d0a8